export { default as AcceptedPaymentMethods } from './AcceptedPaymentMethods';
export { default as FunnelOnlineAcceptedPaymentMethods } from './FunnelOnlineAcceptedPaymentMethods';
